"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
require("../../foundations/fonts");
require("../../foundations/color-palette");
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _templateObject;
var DateStyle = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  font-family: var(--bf-lead-font);\n  color: var(--bf-dark-grey);\n  padding: 16px 0 32px; /* might need updating once layout component is added */\n  font-size: 12px;\n  line-height: 16px;\n  padding: 24px;\n\n  @media (min-width: ", ") {\n    padding: 20px;\n    font-size: 14px;\n    line-height: 28px;\n  }\n"])), _bfBaseStyles.Breakpoints.s);
var DateDisplay = function DateDisplay(_ref) {
  var text = _ref.text;
  return _react.default.createElement(DateStyle, null, text);
};
var _default = DateDisplay;
exports.default = _default;